
export class AttributeReference {
    public name: string = '';
    public entity?: string = '';

    constructor(name: string, entity: string) {
        this.name = name;
        this.entity = entity;
    }
}
